import { BasketChipTone } from "@trader-dashboard/shared";

type AlertChipProps = {
  label: string;
  tone: BasketChipTone;
};

const TONE_CLASSES: Record<BasketChipTone, string> = {
  watch: "bg-amber-100 text-amber-800 border-amber-300",
  yellow: "bg-orange-100 text-orange-800 border-orange-300",
  red: "bg-red-100 text-red-800 border-red-300",
  depth: "bg-purple-100 text-purple-800 border-purple-300",
};

export const AlertChip = ({ label, tone }: AlertChipProps): React.ReactNode => (
  <span
    className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium tabular-nums ${TONE_CLASSES[tone]}`}
  >
    {label}
  </span>
);
